import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faGift, faCube, faAt, faCreditCard, faFileInvoice, faPlus, faUserPlus, faHistory, faCog, faQuestionCircle, faToggleOn, faToggleOff, faMapMarkerAlt, faSlidersH, faUser, faMugHot, faWallet, faPencilAlt, faShoppingCart, faChartBar, faMapMarkedAlt, faCheckCircle, faDotCircle, faCircle, faMoneyCheckAlt, faDonate, faRedo, faAmbulance, faDesktop, faStore, faExchangeAlt, faSignOutAlt, faDharmachakra, faTimes, faInfoCircle, faFilter, faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { portalCfg } from '../../portal.router.config'
import { portal_config, custom_assets, domainName } from '../../portal.config'
import { isRetina } from '../utils/util';
import defaultTheme from '../theme.css';
import { SvgIcon } from '@material-ui/core'

var iconStyle = {
    marginRight: defaultTheme.spacing * 2,
    marginBottom: 0,
}
var iconStyleRotate180 = {
    marginRight: defaultTheme.spacing * 2,
    marginBottom: 0,
    //transform: 'rotate(180deg)'
}
export const HomeIcon = (props) => {
    if (portal_config[domainName].replaceIconWithFont && portal_config[domainName].replaceIconWithFont.home) {
        return <FontAwesomeIcon icon={faHome} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} />
    } else {
        if (portal_config[domainName].usingLocalIcon) {
            var path = portalCfg.publicPath + '/assets';
            if (custom_assets[domainName].customIcon) {
                path = portalCfg.publicPath + '/custom_assets';
            }
            return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/home.png", path + "/icons/home@2x.png")} />
        }
        return <FontAwesomeIcon icon={faHome} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} />
    }
}

export const HomeActiveIcon = (props) => {
    if (portal_config[domainName].replaceIconWithFont && portal_config[domainName].replaceIconWithFont.home) {
        return <FontAwesomeIcon icon={faHome} color={defaultTheme.palette.icon.acitve} size="lg" style={iconStyle} />
    } else {
        if (portal_config[domainName].usingLocalIcon) {
            var path = portalCfg.publicPath + '/assets';
            if (custom_assets[domainName].customIcon) {
                path = portalCfg.publicPath + '/custom_assets';
            }
            return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/home_active.png", path + "/icons/home_active@2x.png")} />
        }
        return <FontAwesomeIcon icon={faHome} color={defaultTheme.palette.icon.acitve} size="lg" style={iconStyle} />
    }
}
export const OfferIcon = (props) => {
    if (portal_config[domainName].replaceIconWithFont && portal_config[domainName].replaceIconWithFont.home) {
        return <FontAwesomeIcon icon={faGift} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} />
    } else {
        if (portal_config[domainName].usingLocalIcon) {
            var path = portalCfg.publicPath + '/assets';
            if (custom_assets[domainName].customIcon) {
                path = portalCfg.publicPath + '/custom_assets';
            }
            return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/offers.png", path + "/icons/offers@2x.png")} />
        }
        return <FontAwesomeIcon icon={faGift} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} />
    }
}

export const OfferActiveIcon = (props) => {
    if (portal_config[domainName].replaceIconWithFont && portal_config[domainName].replaceIconWithFont.home) {
        return <FontAwesomeIcon icon={faGift} color={defaultTheme.palette.icon.acitve} size="lg" style={iconStyle} />
    } else {
        if (portal_config[domainName].usingLocalIcon) {
            var path = portalCfg.publicPath + '/assets';
            if (custom_assets[domainName].customIcon) {
                path = portalCfg.publicPath + '/custom_assets';
            }
            return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/offers_active.png", path + "/icons/offers_active@2x.png")} />
        }
        return <FontAwesomeIcon icon={faGift} color={defaultTheme.palette.icon.acitve} size="lg" style={iconStyle} />
    }
}
export const GiftIcon = (props) => {
        return <FontAwesomeIcon icon={faGift} size="lg" color={defaultTheme.palette.icon.default} style={iconStyle} />
}

export const OrdersIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/order.png", path + "/icons/order@2x.png")} />
    }
    return <FontAwesomeIcon icon={faCube} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} />
}

export const OrdersActiveIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/order_active.png", path + "/icons/order_active@2x.png")} />
    }
    return <FontAwesomeIcon icon={faCube} color={defaultTheme.palette.icon.acitve} size="lg" style={iconStyle} />
}
export const MapIcon = (props) => {
    return <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} />
}

export const MapActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faMapMarkerAlt} color={defaultTheme.palette.icon.acitve} size="lg" style={iconStyle} />
}

export const ProfileIcon = (props) => <img {...props} style={{ height: 24, width: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/profile.png", portalCfg.publicPath + "/assets/icons/profile@2x.png")} />
export const SettingIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/settings.png", path + "/icons/settings@2x.png")} />
    }
    return <FontAwesomeIcon icon={faCog} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}

export const MyProfileIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={path + "/icons/contact.png"} />
}
export const ReferAFriendIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/refer_friend.png", path + "/icons/refer_friend@2x.png")} />
    }
    return <FontAwesomeIcon icon={faAt} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const MyAccountIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/people.png", path + "/icons/people@2x.png")} />
    }
    return <FontAwesomeIcon icon={faUser} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const RewardsTransactionsIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/receipt.png", path + "/icons/receipt@2x.png")} />
    }
    return <FontAwesomeIcon icon={faFileInvoice} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const OrderHistoryIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/history.png", path + "/icons/history@2x.png")} />
    }
    return <FontAwesomeIcon icon={faHistory} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const NotificationsIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/notifications.png", path + "/icons/notifications@2x.png")} />
}
export const LogoutIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    var customColorIcon = portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : null;
    if(customColorIcon)
        return <FontAwesomeIcon icon={faSignOutAlt} color={customColorIcon} size="lg" style={iconStyle} />
    else return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/exit.png", path + "/icons/exit@2x.png")} />
}

export const ExpandMore = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={path + "/icons/expand_more.png"} />
}
export const ExpandLess = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={path + "/icons/expand_less.png"} />
}
export const CheckIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    //console.log('CheckIcon  path=',path)
    return <img style={{ height: 24, width: 24 }} {...props} src={isRetina(path + "/icons/check.png", path + "/icons/check@2x.png")} />
}

export const SuccessIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    //console.log('CheckIcon  path=',path)
    return <img style={{ height: 100, width: 100 }} {...props} src={isRetina(path + "/icons/success@2x.png", path + "/icons/success@3x.png")} />
}

export const ErrorIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    //console.log('CheckIcon  path=',path)
    return <img style={{ height: 100, width: 100 }} {...props} src={isRetina(path + "/icons/error.png", path + "/icons/error.png")} />
}
export const CheckIconPrimary = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/check_not_done.png", path + "/icons/check_not_done@2x.png")} />
}
export const FacebookIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 12 }} src={path + "/icons/facebook.png"} />
}
export const GoogleIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={path + "/icons/google.png"} />
}
export const MenuIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={path + "/icons/menu.png"} />
}
export const WalletIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 18, width: 18 }} src={isRetina(path + "/icons/wallet.png", path + "/icons/wallet@2x.png")} />
}

export const BarcodeScanIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/barcode-scan.png", path + "/icons/barcode-scan@2x.png")} />
}
export const UnitIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 18, width: 18 }} src={isRetina(path + "/icons/redeem.png", path + "/icons/redeem@2x.png")} />
}

export const CyprusFlagIcon = (props) => <img {...props} style={{ height: 24, width: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/cyprus_flag.png", portalCfg.publicPath + "/assets/icons/cyprus_flag@2x.png")} />
export const UKFlagIcon = (props) => <img {...props} style={{ height: 24, width: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/uk_flag@2x.png", portalCfg.publicPath + "/assets/icons/uk_flag@2x.png")} />

export const ArrowDownIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 12, width: 12, objectFit: 'contain' }} src={isRetina(path + "/icons/arrow_down.png", path + "/icons/arrow_down@2x.png")} />
}
export const ArrowRightIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/arrow_righ.png", path + "/icons/arrow_righ@2x.png")} />
}
export const CancelIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/cancel.png", path + "/icons/cancel@2x.png")} />
}
export const DeliveryIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/delivery.png", path + "/icons/delivery@2x.png")} />
}
export const PickUpIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/pickup.png", path + "/icons/pickup@2x.png")} />
}
export const OrderHeaderIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 32, height: 32 }} src={isRetina(path + "/icons/raised_hand.png", path + "/icons/raised_hand@2x.png")} />
}
export const ShippingIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/local_shipping.png", path + "/icons/local_shipping@2x.png")} />
}
export const MopedIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/moped.png", path + "/icons/moped@2x.png")} />
}
export const TimeIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/time.png", path + "/icons/time@2x.png")} />
}


export const PlaceActiveIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/place_active.png", path + "/icons/place_active@2x.png")} />
    }
    return <FontAwesomeIcon icon={faMapMarkerAlt} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const PlaceActiveIcon2x = (props) => {
    // if (portal_config[domainName].usingLocalIcon) {
    //     var path = portalCfg.publicPath + '/assets';
    //     if (custom_assets[domainName].customIcon) {
    //         path = portalCfg.publicPath + '/custom_assets';
    //     }
    //     return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/place_active.png", path + "/icons/place_active@2x.png")} />
    // }
    return <FontAwesomeIcon icon={faMapMarkerAlt} color={'#db0000'} size="2x" style={iconStyle} />
}
export const LocationOnIcon = (props) => {
    // if (portal_config[domainName].usingLocalIcon) {
    //     var path = portalCfg.publicPath + '/assets';
    //     if (custom_assets[domainName].customIcon) {
    //         path = portalCfg.publicPath + '/custom_assets';
    //     }
    //     return <img {...props} style={{ height: 32, width: 32 }} src={isRetina(path + "/icons/location_on.png", path + "/icons/location_on@2x.png")} />
    // }
    return <FontAwesomeIcon {...props} icon={faMapMarkerAlt} color={'#db0000'} size="2x" style={iconStyle} />
}
export const LocationOnWhiteIcon = (props) => {
    return <FontAwesomeIcon {...props} icon={faMapMarkerAlt} color={'#fff'} width={48} height={48} style={iconStyle} />
}
export const BackOnPrimaryIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/arrow_back-24px.png", path + "/icons/arrow_back-24px@2x.png")} />
}
export const BackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/arrow_back_black@2x.png", path + "/icons/arrow_back_black@3x.png")} />
}
export const LeftIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/arrow_left.png", path + "/icons/arrow_left@2x.png")} />
}
export const PlaceIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/place.png", path + "/icons/place@2x.png")} />
}
export const PlaceBlackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/place_black.png", path + "/icons/place_black@2x.png")} />
}
export const TuneIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 32, width: 32 }} src={isRetina(path + "/icons/tune.png", path + "/icons/tune@2x.png")} />
    }
    return <FontAwesomeIcon {...props} icon={faSlidersH} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const TuneWhiteIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 32, width: 32 }} src={isRetina(path + "/icons/tune_white.png", path + "/icons/tune_white@2x.png")} />
    }
    return <FontAwesomeIcon {...props} icon={faSlidersH} color={defaultTheme.palette.icon.acitve} size="lg" style={iconStyle} />
}
export const TocIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/toc.png", path + "/icons/toc@2x.png")} />
}
export const CurrentLocationIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/current_location.png", path + "/icons/current_location.png")} />
}
export const SwichGreenActiveIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 44 }} src={isRetina(path + "/icons/switch_active_green.png", path + "/icons/switch_active_green@2x.png")} />
    }
    return <FontAwesomeIcon icon={faToggleOn} color={defaultTheme.palette.background.switch} size="2x" style={iconStyle} />
}

export const SwichActiveIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 44 }} src={isRetina(path + "/icons/switch_active.png", path + "/icons/switch_active@2x.png")} />
    }
    return <FontAwesomeIcon icon={faToggleOn} color={defaultTheme.palette.primary.main} size="2x" style={iconStyle} />
}
export const SwichIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 44 }} src={isRetina(path + "/icons/switch.png", path + "/icons/switch@2x.png")} />
    }
    return <FontAwesomeIcon icon={faToggleOff} color={defaultTheme.palette.background.switch} size="2x" style={iconStyleRotate180} />
}
export const CameraIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 18, height: 18 }} src={isRetina(path + "/icons/camera.png", path + "/icons/camera@2x.png")} />
}
export const MaleIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 19, height: 26 }} src={isRetina(path + "/icons/boy.png", path + "/icons/boy@2x.png")} />
}
export const FemaleIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 19, height: 25 }} src={isRetina(path + "/icons/woman.png", path + "/icons/woman@2x.png")} />
}
export const EditIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/edit.png", path + "/icons/edit@2x.png")} />
}
export const EditWhiteIcon = (props) => <FontAwesomeIcon icon={faPencilAlt} color={'#ffffff'} size="lg" style={iconStyle} />
export const EditWhiteMDIcon = (props) => <FontAwesomeIcon icon={faPencilAlt} color={'#ffffff'} size="md" style={iconStyle} />
export const EditWhiteSmallIcon = (props) => <FontAwesomeIcon icon={faPencilAlt} color={'#ffffff'} size="sm" style={iconStyle} />
export const HelpIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/help.png", path + "/icons/help@2x.png")} />
    }
    return <FontAwesomeIcon icon={faQuestionCircle} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const DeleteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 18, height: 18 }} src={isRetina(path + "/icons/delete.png", path + "/icons/delete@2x.png")}  {...props}/>
}

export const MailIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/mail.png", path + "/icons/mail@2x.png")} />
}
export const WaveHandIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 32, height: 32 }} src={isRetina(path + "/icons/waving-hand-sign.png", path + "/icons/waving_hand_sign@2x.png")} />
}
export const RisedHandIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 32, height: 32 }} src={isRetina(path + "/icons/raised-hand_270b.png", path + "/icons/raised-hand_270b@2x.png")} />
}
export const PrivacyIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/policy.png", path + "/icons/policy@2x.png")} />
}
export const MailWhiteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/mail_outline.png", path + "/icons/mail_outline@2x.png")} />
}
export const TermConditionIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/term_condition_white.png", path + "/icons/term_condition_white@2x.png")} />
}
export const FAQIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/fqa_outline.png", path + "/icons/fqa_outline@2x.png")} />
}
export const MoreInfoIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/more.png", path + "/icons/more@2x.png")} />
}
export const PhoneIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/phone_white.png", path + "/icons/phone_white@2x.png")} />
}
export const WebsiteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/website.png", path + "/icons/website@2x.png")} />
}
export const WalletWhiteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/wallet_white.png", path + "/icons/wallet_white@2x.png")} />
}
export const PaymentsIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/payments.png", path + "/icons/payments@2x.png")} />
}
export const SpendingPreferenceIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/spending_light.png", path + "/icons/spending_light@2x.png")} />
}

export const ParticipatingSchemesIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/participating_schemes.png", path + "/icons/participating_schemes@2x.png")} />
}
export const AddressIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/address.png", path + "/icons/address@2x.png")} />
}
export const VisaIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 15, width: 46 }} src={isRetina(path + "/icons/visa.png", path + "/icons/visa@2x.png")} />
}
export const DefaultCard = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_unknown.png"} />
}
export const AmexIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_amex.png"} />
}
export const DinnerIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_diners.png"} />
}
export const DiscoverIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_discover.png"} />
}
export const JCBIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_jcb.png"} />
}
export const MasterCardIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_mastercard.png"} />
}
export const VisaCardIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_visa.png"} />
}
export const UnionPayIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/unionpay.png"} />
}
export const MasterIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 32, width: 32,objectFit:'contain' }} src={isRetina(path + "/icons/master.png", path + "/icons/master@2x.png")} />
}
export const PaypalIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/paypal_logo.png", path + "/icons/paypal_logo@2x.png")} />
}
export const VNPayIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/vnpay.png", path + "/icons/vnpay.png")} />
}
export const DeleteWhiteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 18, height: 18 }} src={isRetina(path + "/icons/delete_outline.png", path + "/icons/delete_outline@2x.png")} />
}
export const AddIcon = (props) => {
    return <FontAwesomeIcon icon={faPlus} color={defaultTheme.palette.icon.acitve2} size="x" style={iconStyle} />
}
export const PersonAddIcon = (props) => {
    return <FontAwesomeIcon icon={faUserPlus} color={defaultTheme.palette.icon.acitve2} size="2x" style={iconStyle} />
}

export const CartItemIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/cart_item.png", path + "/icons/cart_item@2x.png")} />
}
export const AddCommentIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/add_comment.png", path + "/icons/add_comment@2x.png")} />
}
export const HourglassIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/hourglass_top.png", path + "/icons/hourglass_top@2x.png")} />
}
export const HelloOrderIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ width: 165, height: 91 }} src={isRetina(path + "/icons/hello_order.png", path + "/icons/hello_order@2x.png")} />
}
export const CupIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/local_cafe-24px.png", path + "/icons/local_cafe-24px@2x.png")} />
    }
    return <FontAwesomeIcon icon={faMugHot} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const USAFlagIcon = (props) => <img {...props} style={{ width: 24, height: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/usa_flag.png", portalCfg.publicPath + "/assets/icons/usa_flag@2x.png")} />
export const GREFlagIcon = (props) => <img {...props} style={{ width: 24, height: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/greece_flag.png", portalCfg.publicPath + "/assets/icons/greece_flag@2x.png")} />
export const GoogleMapIcon = (props) => <img {...props} style={{ width: 36, height: 36 }} src={portalCfg.publicPath + "/assets/icons/google-maps.png"} />

export const RadioCheckedIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/radio_button_checked.png", path + "/icons/radio_button_checked@2x.png")} />
}
export const RadioIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/radio_unchecked.png", path + "/icons/radio_unchecked@2x.png")} />
}
export const RadioCheckedWhiteIcon = (props) => {

    return <FontAwesomeIcon icon={faCheckCircle} color={'#fff'} size="lg" style={{marginTop:-16, marginLeft:-16}} {...props}/>
}
export const RadioWhiteIcon = (props) => {

    return <FontAwesomeIcon icon={faCircle} color={'#fff'} size="lg" style={iconStyle} {...props}/>
}
export const CartHomeIcon = (props) => <img {...props} style={{ height: 80, width: 80 }} src={portalCfg.publicPath + "/assets/images/online_shopping.png"} />
export const ShoppingCartIcon = (props) => <FontAwesomeIcon icon={faShoppingCart} color={'#000'} size="1x" style={iconStyle} />

export const FavoriteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/favorite.png", path + "/icons/favorite@2x.png")} />
}
export const FavoriteActiveIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/favorite_active.png", path + "/icons/favorite_active@2x.png")} />
}
export const CardIcon = (props) => {
    return <FontAwesomeIcon icon={faCreditCard} color={defaultTheme.palette.icon.acitve} size="2x" style={iconStyle} />
}
export const TopupIcon = (props) => {
    return <FontAwesomeIcon icon={faDonate} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const ReorderIcon = (props) => {
    return <FontAwesomeIcon icon={faRedo} color={'#3498db'} size="sm" style={iconStyle} />
}
export const StarIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 52, width: 52 }} src={isRetina(path + "/icons/start.png", path + "/icons/start@2x.png")} />
}
export const OrdersHomeIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 52, width: 52, color: '#ffffff' }} src={isRetina(path + "/icons/orders.svg", path + "/icons/orders.svg")} />
}

export const ServiceRequestIcon = (props) => {
    var customColorIcon = portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : null;
    return <FontAwesomeIcon icon={faDharmachakra} color={customColorIcon ? customColorIcon : defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}

export const RedeemPassIcon = (props) => {
    return <FontAwesomeIcon icon={faGift} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} />
}
export const ReNewIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24, color: '#ffffff' }} src={isRetina(path + "/icons/autorenew_black_24dp.svg", path + "/icons/autorenew_black_24dp.svg")} />
}
export const DateRangeBlackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24, color: '#ffffff' }} src={isRetina(path + "/icons/date_range_black_24dp.svg", path + "/icons/date_range_black_24dp.svg")} />
}
export const CalanderTodayBlackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24, color: '#ffffff' }} src={isRetina(path + "/icons/calendar_today_black_24dp.svg", path + "/icons/calendar_today_black_24dp.svg")} />
}
export const ReceiptBlackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} style={{ height: 24, width: 24, color: '#ffffff' }} src={isRetina(path + "/icons/receipt_long_black_24dp.svg", path + "/icons/receipt_long_black_24dp.svg")} />
}

export const SubcriptionActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faDesktop} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props}/>
}

export const SubcriptionIcon = (props) => {
    return <FontAwesomeIcon icon={faDesktop} color={defaultTheme.palette.icon.deactive} size="lg" style={iconStyle} {...props}/>
}

// export const WalletJournalBlackIcon = (props) => {
//     var path = portalCfg.publicPath + '/assets';
//     if (custom_assets[domainName].customIcon) {
//         path = portalCfg.publicPath + '/custom_assets';
//     }
//     return <img {...props} style={{ height: 24, width: 24, color: '#6D1F37' }} src={isRetina(path + "/icons/ic24_sync.svg", path + "/icons/ic24_sync.svg")} />
// }
export const WalletJournalBlackIcon = (props) => {
    return <FontAwesomeIcon icon={faExchangeAlt} color={portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}

export const StoreActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faStore} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props}/>
}

export const StoreIcon = (props) => {
    return <FontAwesomeIcon icon={faStore} color={defaultTheme.palette.icon.deactive} size="lg" style={iconStyle} {...props}/>
}

export const ReOrderIconNew = (props) => <img src={portalCfg.publicPath + "/assets/icons/reorder.svg"} style={{width: 24, height: 24}} {...props}/>


export const ReOrderIconNew1 = (props) => {
    return <SvgIcon width="19.998" height="16" viewBox="0 0 31.99983 27" {...props}>
            <path d="M18.45783,0A13.53082,13.53082,0,0,0,4.92713,13.29712l-.0025.01245v.03662c-.00061.05176-.00781.10205-.00781.15381,0,.01367.00738.02515.00781.03857v4.48975L2.16,15.09277A1.25042,1.25042,0,1,0,.33967,16.80762l4.9248,5.22949c.00458.00488.01117.00635.01581.011l.0279.02734c.00469.00464.00616.011.011.01538a1.20328,1.20328,0,0,0,.18605.11743,1.21223,1.21223,0,0,0,.17328.1167l.00927.00635c.0058.00244.01288.00146.01874.00391a1.20844,1.20844,0,0,0,.93744-.00025l.01855-.00439.00666-.0044a1.20765,1.20765,0,0,0,.16632-.1123,1.1717,1.1717,0,0,0,.19659-.124c.005-.00463.00647-.01123.01135-.01611l.02717-.02783c.00445-.00488.0108-.00611.01519-.01074l4.90821-5.2295a1.24979,1.24979,0,1,0-1.82227-1.71093L7.42463,18.02148v-4.675A11.03794,11.03794,0,1,1,18.45783,24.5a1.25,1.25,0,0,0,0,2.5,13.50007,13.50007,0,1,0,0-27Z" />
        </SvgIcon>
}
export const WalletBlackIcon = (props) => {
    return <FontAwesomeIcon icon={faWallet} color={portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const CloseIcon = (props) => {
    return <FontAwesomeIcon icon={faTimes} color={portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : defaultTheme.palette.primary.contrastText} size="md" style={iconStyle} {...props}/>
}
export const PKPassIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24}} src={isRetina(path + "/icons/apple_wallet.png", path + "/icons/apple_wallet.png")} {...props} />
}
export const GooglePayIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 20, width: 20}} src={isRetina(path + "/icons/google_pay.png", path + "/icons/google_pay.png")} {...props}/>
}

export const StripeIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/stripe_logo.png", path + "/icons/stripe_logo.png")} />
}
export const FACIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img {...props} src={isRetina(path + "/icons/fac_logo.png", path + "/icons/fac_logo.png")} />
}
export const InvoiceIcon = (props) => {
    return <FontAwesomeIcon icon={faFileInvoice} color={defaultTheme.palette.icon.deactive} size="lg" style={iconStyle} {...props}/>
}
export const InvoiceActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faFileInvoice} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props}/>
}
export const TabWalletIcon = (props) => {
    return <FontAwesomeIcon icon={faWallet} color={defaultTheme.palette.icon.deactive} size="lg" style={iconStyle} {...props}/>
}
export const TabWalletActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faWallet} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props}/>
}
export const InformPasswordIcon = (props) => <FontAwesomeIcon icon={faInfoCircle} color={defaultTheme.palette.primary.main} size="md" {...props} />
export const FilterIcon = (props) => {
    return <FontAwesomeIcon icon={faFilter} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props}/>
}
export const UpIcon = (props) => {
    return <FontAwesomeIcon icon={faAngleUp} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const DownIcon = (props) => {
    return <FontAwesomeIcon icon={faAngleDown} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}